export const CASE_NAME_MAX_LENGTH = 180;
export const COMPANY_NAME_MAX_LENGTH = 160;
export const COMPANY_REGISTRATION_NUMBER_MAX_LENGTH = 180;
export const CUSTOM_PROPERTY_EMAIL_MAX_LENGTH = 250;
export const CUSTOM_PROPERTY_URL_MAX_LENGTH = 2000;
export const CUSTOM_PROPERTY_TEXT_SINGLELINE_MAX_LENGTH = 250;
export const CUSTOM_PROPERTY_TEXT_MULTILINE_MAX_LENGTH = 1500;
